export const CircuitoTomoData = [
  {
    pregunta: "¿Cuánto pesa?",
    name: "peso",
    valor: null,
    visible: true,
    input: true,
    key: 0
  },
  {
    pregunta: "¿Tiene un peso superior a los 180kg?",
    name: "pesoSuperiorCritico",
    valor: null,
    visible: false,
    key: 1
  },
  {
    pregunta: `¿La orden médica indica con Contraste?`,
    name: "conContraste",
    valor: null,
    visible: true,
    key: 2
  },
  {
    pregunta: `¿Tiene insuficiencia renal?`,
    name: "insRenal",
    valor: null,
    visible: false,
    key: 3
  },
  {
    pregunta: `¿Realizó un laboratorio de Función Renal en los últimos 30 días?`,
    name: "labFuncionRenal",
    valor: null,
    visible: false,
    key: 4
  },
  {
    pregunta: `¿Usted es diabético?`,
    name: "diabetico",
    valor: null,
    visible: false,
    key: 5
  },
  {
    pregunta: `¿Usted es hipertenso?`,
    name: "hipertenso",
    valor: null,
    visible: false,
    key: 6
  },
  {
    pregunta: `¿Se realizó en las últimas 72hs. algún otro estudio con contraste (resonancia, cámara gamma, etc)?`,
    name: "contrasteReciente",
    valor: null,
    visible: false,
    key: 7
  },
];
